import create from "zustand";
import moment from "moment";
import { ContaFiltroType } from "../typings";

interface ContaStore {
  filters: Partial<ContaFiltroType>;
  reset: (params?: Partial<ContaFiltroType>) => void;
  update: (
    filed: keyof Partial<ContaFiltroType> | Partial<ContaFiltroType>,
    value?: any
  ) => void;
}

const defaultValue: Partial<ContaFiltroType> = {
  dataInicio: moment().startOf("month").format("YYYY-MM-DD"),
  dataFim: moment().endOf("month").format("YYYY-MM-DD"),
  tipoData: "vencimento",
  page: 1,
  limit: 20,
  atraso: null,
  cobrancaUnificada: null,
  pagamentoDuplicado: null,
  acordo: 0,
  orderDirection: "ASC",
  orderBy: "c.dataVencimento",
  formasPagamentoIds: [],
  categoriasFinanceirasIds: [],
  contasBancariasIds: [],
  extratosBancariosIds: [],
  pago: null,
  contaId: undefined,
  unidadesIds: [],
};

export const useContaStore = create<ContaStore>((set) => ({
  filters: defaultValue,
  update: (
    key: keyof ContaFiltroType | Partial<ContaFiltroType>,
    value?: any
  ) => {
    const next = typeof key === "object" ? { ...key } : { [key]: value };

    const isChangingPage =
      typeof key === "object" ? key.page !== undefined : key === "page";

    set((state) => ({
      filters: {
        ...state.filters,
        ...next,
        page: isChangingPage ? next.page : 1,
      },
    }));
  },
  reset: (params?: Partial<ContaFiltroType>) => {
    set((state) => ({
      filters: { ...defaultValue, operacao: state.filters.operacao, ...params },
    }));
  },
}));
